import { FC } from 'react';
import { TypeDisclaimer } from 'components/library/Typography';
import { motion } from 'motion/react';

import {
  ViaCapSubhead,
  MobileContainer,
  MobileColumn1,
  MobileColumn2,
  MobileSolidLine,
  MobileTextBlock,
} from './via-cap.styled';
import { ViaCapVideoPlayer } from './via-cap-video-player';

// Animation variants
const mobileLineVariants = {
  initial: { scaleX: 0 },
  animate: {
    scaleX: 1,
    transition: {
      duration: 0.8,
      ease: 'easeOut' as const,
    },
  },
};

interface ViaCapElementProps {
  paused?: boolean;
  capsule?: {
    media: {
      src: string;
      alt: string;
      width: number;
      height: number;
      type?: string;
      fallbackSrc: string;
      fallbackStillSrc?: string;
    };
    top: {
      title: string;
      body: string;
    };
    bottom: {
      title: string;
      body: string;
    };
  };
}

export const ViaCapElementSmall: FC<ViaCapElementProps> = ({
  paused,
  capsule = {
    media: {
      src: '',
      fallbackSrc: '',
      alt: '',
      width: 69,
      height: 48,
      type: 'video',
    },
    top: {
      title: '',
      body: '',
    },
    center: {},
    bottom: {
      title: '',
      body: '',
    },
  },
}) => {
  return (
    <MobileContainer>
      <MobileColumn1>
        <MobileSolidLine
          as={motion.div}
          variants={mobileLineVariants}
          initial='initial'
          whileInView='animate'
        />

        <MobileTextBlock>
          <ViaCapSubhead>{capsule.top.title}</ViaCapSubhead>
          <TypeDisclaimer color='inverse-primary'>
            {capsule.top.body}
          </TypeDisclaimer>
        </MobileTextBlock>

        <MobileSolidLine
          as={motion.div}
          variants={mobileLineVariants}
          initial='initial'
          whileInView='animate'
        />

        <MobileTextBlock>
          <ViaCapSubhead>{capsule.bottom.title}</ViaCapSubhead>
          <TypeDisclaimer color='inverse-primary'>
            {capsule.bottom.body}
          </TypeDisclaimer>
        </MobileTextBlock>
      </MobileColumn1>

      <MobileColumn2>
        <ViaCapVideoPlayer
          src={capsule.media.src}
          fallbackSrc={capsule.media.fallbackSrc}
            fallbackStillSrc={capsule.media.fallbackStillSrc}
            paused={paused}
          alt={capsule.media.alt}
          width={500}
          height={375}
        />
      </MobileColumn2>
    </MobileContainer>
  );
};
